import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    pathways: [],
    pathway: 0,
    references: [],
    referenceGroup: 0,
    sections: [],
    section: 0,
    session: 0,
    strings: [],
    videos: {},
  },
  getters: {
    currentPathway: state => state.pathways[state.pathway],
    currentSection: state => state.sections[state.section],
    references: state => state.references[state.referenceGroup],
    referenceGroup: state => state.referenceGroup,
    pathway: state => state.pathway,
    pathwayCount: state => state.pathways.length,
    section: state => state.section,
    sectionCount: state => state.sections.length,
    session: state => state.session,
    strings: state => state.strings,
    string: state => key => {
      let string = (key in state.strings) ? state.strings[key] : '';
      if (!string) {
        string = key;
      }
      return string;
    },
    videos: state => state.videos,
    video: state => id => state.videos[id],
  },
  mutations: {
    SetPathways: (state, pathways) => state.pathways = pathways,
    SetCurrentPathway: (state, pathway) => state.pathway = pathway,
    SetReferences: (state, references) => state.references = references,
    SetReferenceGroup: (state, referenceGroup) => state.referenceGroup = referenceGroup,
    SetSections: (state, sections) => state.sections = sections,
    SetSection: (state, section) => state.section = section,
    SetSession: (state, session) => state.session = session,
    StoreSessionPathway: (state, session) => state.session = session,
    SetStrings: (state, strings) => state.strings = strings,
    SetVideos: (state, videos) => state.videos = videos,
  },
  actions: {
    PrevSection: (state, commit) => {
      const section = Math.max(state.section - 1, 0);
      commit('SetSection', section);
    },
    NextSection: ({ commit, state }) => {
      const section = Math.min(state.section + 1, state.sections.length - 1);
      commit('SetSection', section);
    },
    NewSession: ({ commit }) => {
      commit('SetSession', Date.now());
    }
  },
  modules: {
  },
})
